module.exports = __webpack_public_path__ + "static/media/edoge.1501e8dd.svg";